export const colors = {
  cejnBlue: "#002664",
  gray: {
    light: "#eee",
    medium: "#ccc",
    dark: "#333",
  },
  white: "#FFF",
};
